import { Controller } from '@hotwired/stimulus'
import { toggleVisibility } from 'utils/toggle_element_visibility'
import Cookies from 'js-cookie'

export default class extends Controller {
  static targets = ['on', 'off']
  static values = { cookie: String }

  initialize() {
    if (!this.hasOnTarget && !this.hasOffTarget) console.log("ElementVisibilityController must define at least one target")
  }

  change(event) {
    const { checked } = event.target
    if (this.cookieValue !== "") {
      Cookies.set(this.cookieValue, checked)
    }

    toggleVisibility(this.onTarget, checked)
    toggleVisibility(this.offTarget, !checked)
  }

  toggleOn() {
    if (this.hasOnTarget) toggleVisibility(this.onTarget, true)
    if (this.hasOffTarget) toggleVisibility(this.offTarget, false)
  }

  toggleOff() {
    if (this.hasOnTarget) toggleVisibility(this.onTarget, false)
    if (this.hasOffTarget) toggleVisibility(this.offTarget, true)
  }
}
